import React from "react";
import {
  CaseStudyBannerContainer,
  CaseStudyBannerParagraph,
  CaseStudyBannerParagraphHeader,
  CaseStudyBannerParagraphText,
  CaseStudyBannerImage,
  CaseStudyBadges,
  CaseStudyBadge,
  Bold,
  BackButton,
} from "./CaseStudyBanner.styled";
import SubSectionText from "components/SubSectionText/SubSectionText";
import Image from "components/Image/Image";
import { Trans } from "react-i18next";

import useDevice from "hooks/useDevice";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { ReactComponent as ArrowLeft } from "assets/images/svg/arr-left.svg";
import { PAGES } from "constants/pages";

const CaseStudyBanner = (props) => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();
  const paddingBottom = isMobile ? "35px" : "85px";
  return (
    <>
      <BackButton href={PAGES.CASE_STUDIES.route}>
        {props.withNavigation && <ArrowLeft />}
        <Trans t={t} i18nKey={props.withNavigation ? "caseStudies.backButton" : ""} />
      </BackButton>
      <CaseStudyBannerContainer>
        <CaseStudyBannerParagraph>
          <CaseStudyBannerParagraphHeader>
            <Trans i18nKey={props.header} components={[<Bold key={0} />]} />
          </CaseStudyBannerParagraphHeader>
          <CaseStudyBannerParagraphText $highlightColor={props.highlightColor}>
            <SubSectionText text={props.text} textColor={"dark"} />
          </CaseStudyBannerParagraphText>
          <CaseStudyBannerParagraphText sx={{ pb: paddingBottom }}>
            <CaseStudyBadges>
              {props.badges &&
                props.badges.map((item, index) => (
                  <CaseStudyBadge
                    key={index}
                    $highlightColor={props.highlightColor}
                  >
                    {item}
                  </CaseStudyBadge>
                ))}
            </CaseStudyBadges>
          </CaseStudyBannerParagraphText>
        </CaseStudyBannerParagraph>
        <CaseStudyBannerImage>
          <Image
            image={props.image}
            height={props.imageHeight}
            objectFit={props.imageObjectFit}
            width={618}
          ></Image>
        </CaseStudyBannerImage>
      </CaseStudyBannerContainer>
    </>
  );
};
CaseStudyBanner.propTypes = {
  children: PropTypes.node,
  text: PropTypes.string,
  header: PropTypes.string,
  image: PropTypes.string,
  badges: PropTypes.array,

  highlightColor: PropTypes.string,

  arrowLenght: PropTypes.string,
  showArrowhead: PropTypes.bool,
  imageHeight: PropTypes.number,
  imageObjectFit: PropTypes.string,
  withNavigation: PropTypes.bool,
};

CaseStudyBanner.defaultProps = { imageHeight: 464, withNavigation: true };
export default CaseStudyBanner;
